import { Service, ServiceCodes } from '@checkout-v2/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { SERVICES } from '../checkout-state';

export const LOAD_SERVICES = '[Checkout] Load services';
export const LOAD_SERVICES_FAIL = '[Checkout] Load services Fail';
export const LOAD_SERVICES_SUCCESS = '[Checkout] Load services Success';
export const RESET_LOADED_SERVICES = '[Checkout] Reset loaded services';

export const SELECT_SERVICES_ACTIVE_OPTION = '[Checkout] Select services active option';

export class LoadServices extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_SERVICES;

  constructor() {
    super(SERVICES);
  }
}

export class LoadServicesFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_SERVICES_FAIL;

  constructor() {
    super(SERVICES);
  }
}

export class LoadServicesSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_SERVICES_SUCCESS;

  constructor(public payload: Service[]) {
    super(SERVICES);
  }
}

export class ResetServices extends StateUtils.LoaderResetAction {
  readonly type = RESET_LOADED_SERVICES;

  constructor() {
    super(SERVICES);
  }
}

export class SelectServicesActiveOption implements Action {
  readonly type = SELECT_SERVICES_ACTIVE_OPTION;

  constructor(public payload: ServiceCodes | undefined) {}
}

export type ServicesActions =
  | LoadServices
  | LoadServicesSuccess
  | LoadServicesFail
  | ResetServices
  | SelectServicesActiveOption;
